import { ChartState, RootState } from '@/types';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import { ChartActions } from '../actions/charts';
import { axios } from '@/helpers/axios';

const state: ChartState = {
  data: [],
  chartStatus: 'idle',
};

const getters: GetterTree<ChartState, RootState> = {
  data: state => state.data,
  chartStatus: state => state.chartStatus,
};

const mutations: MutationTree<ChartState> = {
  setData: (state, newVal) => {
    state.data = newVal;
  },
  [ChartActions.CHART_SUCCESS]: (state, newVal) => {
    state.chartStatus = 'success';
    state.data = newVal.data;
  },
  [ChartActions.CHART_ERROR]: state => {
    state.chartStatus = 'error';
  },
  [ChartActions.CHART_PROCESSING]: state => {
    state.chartStatus = 'loading';
  },
};

const actions: ActionTree<ChartState, RootState> = {
  [ChartActions.CHART_REQUEST]: (
    { commit },
    payload: { chartId: number; basinId: number },
  ) => {
    commit(ChartActions.CHART_PROCESSING);

    return new Promise((resolve, reject) => {
      axios
        .get(`charts/${payload.chartId}/${payload.basinId}`)
        .then(response => {
          if (response.data.error) {
            commit(ChartActions.CHART_ERROR);
          }
          commit(ChartActions.CHART_SUCCESS, response.data);
          resolve(response.data);
        })
        .catch(err => {
          commit(ChartActions.CHART_ERROR);
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
